import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'folder-icon-blue',
  templateUrl: './folder-icon-blue.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FolderIconBlueComponent {}
